/* eslint-disable no-param-reassign */
import { SliceCaseReducers, ValidateSliceCaseReducers, createSlice } from '@reduxjs/toolkit';

import { Store } from '@sv-support-sdk/shared-types';

type INotificationsState = Store.Notifications.INotificationsState;

export const initialState: INotificationsState = {
  notifications: [],
};

const notificationsSlice = <T extends INotificationsState, Reducers extends SliceCaseReducers<T>>({
  name = 'notifications',
  initialState,
  reducers,
}: {
  name: string;
  initialState: T;
  reducers: ValidateSliceCaseReducers<T, Reducers>;
}) =>
  createSlice({
    name,
    initialState,
    reducers: {
      addNotification(state, action) {
        state.notifications.push(action.payload);
      },
      removeNotification(state, action) {
        state.notifications = state.notifications.filter(({ id }) => id !== action.payload);
      },
      ...reducers,
    },
  });

export default notificationsSlice;
